'use client';

import { css } from 'styled-components';

import { baseTheme } from '.';
import type { BaseColorsType, BaseColorsTypeOld } from '../types/colors';

type Args =
  | {
      colors: BaseColorsType;
      hasNewColorTheming: true;
    }
  | {
      colors: BaseColorsTypeOld;
      hasNewColorTheming: false;
    };

export function baseDark(args: Args) {
  const { colors, hasNewColorTheming } = args;
  return css`
    ${baseTheme.text}: ${colors.text};
    ${baseTheme.textHover}: ${colors.textHover};

    ${baseTheme.background1}: ${colors.background1};
    ${baseTheme.background2}: ${colors.background2};
    ${baseTheme.card}: ${colors.card};

    ${hasNewColorTheming &&
    `
      ${baseTheme.buttonBg}:${colors.buttonBg};
      ${baseTheme.buttonText}:${colors.buttonText};
      ${baseTheme.buttonIcon}:${colors.buttonIcon};
      ${baseTheme.buttonBorder}:${colors.buttonBorder};
    `}

    ${baseTheme.primary1}: ${colors.primary1};
    ${baseTheme.primary2}: ${colors.primary2};
    ${baseTheme.primary3}: ${colors.primary3};

    ${baseTheme.purple}: ${colors.purple};

    ${baseTheme.success1}: ${colors.success1};
    ${baseTheme.success2}: ${colors.success2};
    ${baseTheme.warning1}: ${colors.warning1};
    ${baseTheme.error}: ${colors.error};
    ${baseTheme.info}: ${colors.info};
    ${baseTheme.info2}: ${colors.info2};

    ${baseTheme.black1}: ${colors.black1};
    ${baseTheme.black3}: ${colors.black3};
    ${baseTheme.black5}: ${colors.black5};

    ${baseTheme.grey1}: ${colors.grey1};
    ${baseTheme.grey3}: ${colors.grey3};
    ${baseTheme.grey5}: ${colors.grey5};
    ${baseTheme.grey6}: ${colors.grey6};
    ${baseTheme.grey7}: ${colors.grey7};
    ${baseTheme.white}: ${colors.white};

    ${baseTheme.elevation}: ${colors.elevation};

    ${baseTheme.borderPrimary}: ${colors.borderPrimary};
    ${baseTheme.borderSecondary}: ${colors.borderSecondary};
  `;
}
